export default "__VITE_ASSET__DoahyLVi__"